import clsx from "clsx";

export default function TeamMemberCard({
  name,
  imageUrl,
  email,
  linkedInUrl,
  className,
}) {
  return (
    <div className={clsx("flex flex-col items-center", className)}>
      <img
        className="h-40 w-40 rounded-full object-cover"
        src={imageUrl || "https://via.placeholder.com/150"}
        alt=""
      />
      <div className="mt-4 text-center">
        <h3 className="text-lg font-semibold leading-6 text-gray-900">
          {name}
        </h3>
        <p>
          <a
            href={`mailto:${email}`}
            className="mt-1 text-sm font-normal hover:underline leading-6"
          >
            {email}
          </a>
        </p>
        <a
          href={linkedInUrl}
          target="_blank"
          className="mt-1 text-sm font-semibold leading-6 text-orange-500"
        >
          LinkedIn
        </a>
      </div>
    </div>
  );
}
